import React from 'react';
import { bool, string } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { convertMoneyToNumber, formatAmountOnly } from '../../util/currency';
import { CurrencySymbol } from '../../components';
import { LINE_ITEM_DISCOUNT_CODE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Platform-funded discount code. Customer-only (NOW bears it; the merchant's
 * payout is unaffected), and taken off the final total after VAT, so it is
 * shown last, right above the total.
 */
const LineItemDiscountCodeMaybe = props => {
  const { lineItems, isProvider, discountCode, intl } = props;

  const lineItem = lineItems.find(item => item.code === LINE_ITEM_DISCOUNT_CODE && !item.reversal);

  if (isProvider || !lineItem?.lineTotal) {
    return null;
  }

  const amount = convertMoneyToNumber(lineItem.lineTotal);
  const formatted = formatAmountOnly(intl, amount, 2);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        {discountCode ? (
          <FormattedMessage id="OrderBreakdown.discountCodeWithCode" values={{ code: discountCode }} />
        ) : (
          <FormattedMessage id="OrderBreakdown.discountCode" />
        )}
      </span>
      <span className={css.itemValue}>
        <CurrencySymbol size={16} />
        <span>&nbsp;{formatted}</span>
      </span>
    </div>
  );
};

LineItemDiscountCodeMaybe.defaultProps = {
  discountCode: null,
};

LineItemDiscountCodeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool.isRequired,
  discountCode: string,
  intl: intlShape.isRequired,
};

export default LineItemDiscountCodeMaybe;
